import { Controller, Menu } from '@tencent/workbench';
import canSaveMyTemplate from '@src/utils/can-save-template';
import { MENU_CONFIGS } from '@framework/workbench/ui/save-temp/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitlebarFileMenuConfig, ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import DocsConfig from '@tencent/docs-config';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

@Controller({ menuItems: MENU_CONFIGS })
export class SaveTempController {
    @Menu(ActionType.SAVE_TEMP, 'onClick')
    public saveTemplate(): void {
        import(/* webpackChunkName: "service" */ '@tencent/docs-scenario-components-save-template/dist/pc').then((module) => {
            const showPCSavaTemplate = module.default;
            showPCSavaTemplate({
                title: SlideDataServices.SlideTitleManager()?.title ?? '', // 必填
                padId: window.clientVars ? window.clientVars.padId : '', // 必填
                domainId: window.clientVars ? window.clientVars.domainId : '', // 必填
            });
        });
    }

    @Menu(ActionType.SAVE_TEMP, 'shouldHide')
    public handleHide(): boolean {
        const isSimpleMode = !!(appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false);
        const supportSaveTemp = DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.saveTemp) ?? true;
        return !supportSaveTemp || isSimpleMode;
    }

    @Menu(ActionType.SAVE_TEMP, 'shouldDisabled')
    public handleDisabled(): boolean {
        return !canSaveMyTemplate();
    }
}
